import { marked } from 'marked'
import DOMPurify from 'dompurify'

export function renderMarkdown(text: string, options?: { breaks?: boolean }): string {
  const normalized = text.replace(/\r\n/g, '\n')
  const html = marked.parse(normalized, {
    breaks: options?.breaks ?? false,
    async: false,
  })
  return DOMPurify.sanitize(html)
}
